// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__VT7W-","info":"PatientInfo_info__1qX6d"};